// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".field[data-v-fd373806]{flex:none;width:4rem}.field[data-v-fd373806]  input{text-align:right}", ""]);
// Exports
module.exports = exports;
